import { maxDigits } from "../constants";

const {random, ceil, floor} = Math;
const endDigits = ["1", "3", "7", "9"];

export const isValidN = (N) => {
    return endDigits.includes(N.slice(-1)) && N.length <= maxDigits
}

export const randomN = (digits) => {

    const n = ceil(random() * 9)    // first digit [1-9]
    let Z = n.toString();

    // now do following digits [0-9]
    for (let i = 1; i < digits; i++) {
        const n = floor(random() * 10)
        Z += n.toString()
    }

    if (!isValidN(Z)) {
        Z = Z.slice(0, -1) + endDigits[floor(random() * 4)]
    }

    return Z
}